import React, { FC, useContext } from 'react';

import { AppContext } from '../../containers/appContextContainer';
import { PAGE_ROOT } from './pageUrl';

import './progressCircle.scss';

const ProgressCircle: FC = () => {
    const { pageOrder } = useContext(AppContext);
    const location = window.location.hash.replace('#', '').split('?')[0];
    const currentPage = location.length === 0 ? PAGE_ROOT : location;
    const page = pageOrder.findIndex((p) => p === currentPage) + 1;
    const numOfPages = pageOrder ? pageOrder.length : 1;
    const percentageComplete = pageOrder ? 100 - (page / numOfPages) * 100 : 100;

    const textPosX = () => {
        if (page < 10 && numOfPages < 10) return '8';
        if (page < 10) return '6';
        return '4';
    };

    return (
        <div style={{ margin: '2' }}>
            <svg viewBox="-2 -2 38 38" className="progress-circle" xmlns="http://www.w3.org/2000/svg">
                <circle className="circle-background" cx="16" cy="16" r="15.9155" />
                <circle
                    className="circle-progress"
                    cx="16"
                    cy="16"
                    r="15.9155"
                    strokeDashoffset={percentageComplete}
                    strokeDasharray="100 100"
                    strokeLinecap="round"
                />
                <text className="page-text" x={textPosX()} y="-13" transform="rotate(90)">
                    {page && page.toString()} av {page && numOfPages.toString()}
                </text>
            </svg>
        </div>
    );
};

export default ProgressCircle;
